// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__8DFcg","modal-header":"styles_modal-header__brGNQ","modal-content":"styles_modal-content__nWtGY"};